import {default as After} from './After';

export default {
  After,
};
